<template>
    <va-show-layout>
        <va-show :item="item">
            <v-row justify="center">
                <v-col sm="6">
                    <base-material-card>
                        <template v-slot:heading>
                            <div class="display-2">
                                {{ title }}
                            </div>
                        </template>
                        <v-card-text>
                            <va-field source="ShipmentId"></va-field>
                            <va-field source="ShipmentName"></va-field>
                            <va-field
                                source="DestinationFulfillmentCenterId"
                            ></va-field>
                            <va-field source="ShipmentStatus"></va-field>
                            <va-field source="LabelPrepType"></va-field>
                            <va-field source="AreCasesRequired"></va-field>
                            <va-field
                                source="ConfirmedNeedByDate"
                                type="date"
                            ></va-field>
                        </v-card-text>
                    </base-material-card>
                </v-col>
            </v-row>
        </va-show>
    </va-show-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
